var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "sync-quick-actions" }, [
    _c(
      "div",
      { staticClass: "sync-header", attrs: { slot: "header" }, slot: "header" },
      [
        _c("i", { staticClass: "el-icon-refresh" }),
        _vm._v(" "),
        _c("span", [_vm._v("数据同步")]),
        _vm._v(" "),
        _c(
          "el-tag",
          {
            staticClass: "ml10",
            attrs: {
              type: _vm.syncStatus === "running" ? "warning" : "info",
              size: "mini",
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.syncStatusText) + "\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "quick-actions-content" }, [
      _c("div", { staticClass: "sync-info" }, [
        _c("p", { staticClass: "sync-description" }, [
          _vm._v(
            "\n        快速同步工会和会员数据，确保数据实时性和准确性\n      "
          ),
        ]),
        _vm._v(" "),
        _vm.lastSyncTime
          ? _c("div", { staticClass: "last-sync-time" }, [
              _c("i", { staticClass: "el-icon-time" }),
              _vm._v(" "),
              _c("span", [_vm._v("最后同步：" + _vm._s(_vm.lastSyncTime))]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.loading.fullSync,
              },
              on: { click: _vm.handleFullSync },
            },
            [
              _c("i", { staticClass: "el-icon-refresh" }),
              _vm._v("\n        全量同步\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading.unionBase },
              on: { click: _vm.handleSyncUnionBase },
            },
            [
              _c("i", { staticClass: "el-icon-office-building" }),
              _vm._v("\n        同步工会\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading.unionUser },
              on: { click: _vm.handleSyncUnionUser },
            },
            [
              _c("i", { staticClass: "el-icon-user" }),
              _vm._v("\n        同步会员\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "text" },
              on: { click: _vm.goToSyncPage },
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v("\n        高级设置\n      "),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.showProgress
      ? _c(
          "div",
          { staticClass: "sync-status-bar" },
          [
            _c("el-progress", {
              attrs: {
                percentage: _vm.syncProgress,
                status: _vm.progressStatus,
                "show-text": false,
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "progress-text" }, [
              _vm._v(_vm._s(_vm.progressText)),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }